import React, { useState } from 'react'; // eslint-disable-line
import { PaymentType, PaymentTypesReversed } from '../interfaces/payment_types';

export const usePaymentInfoContainer = () => {
  const [payments, _] = useState<PaymentType[]>( // eslint-disable-line
    Object.values(PaymentTypesReversed),
  );

  return {
    states: {
      payments,
    },
  };
};
